export const WEB_ORIGINATION_SOURCE = 'Web'
export const REALTOR_ORIGINATION_SOURCE = 'Realtor'
export const SCHELLIE_ORIGINATION_SOURCE = 'Schellie'
export const NOTIFICATION_FETCH_LIMIT = 15

export const ROLE_CSM = 'csm'
export const ROLE_OSC = 'osc'
export const ROLE_MANAGER = 'manager'
export const ROLE_DIVISION_MANAGER = 'divmgr'

/** Maps the internal role codes to human readable labels */
export const ROLE_LABELS = {
  [ROLE_CSM]: 'CSM',
  [ROLE_OSC]: 'OSC',
  [ROLE_MANAGER]: 'Manager',
  [ROLE_DIVISION_MANAGER]: 'Division Manager',
}

export const appointmentTypeDurations = {
  'In-Person': [60, 120],
  'Virtual': [15, 30, 60],
  'Phone': [15, 30, 60]
};

export const LEAD = "Lead"
export const PROSPECT = "Prospect"
export const HOMEOWNER = "Homeowner"
export const MARKETING_ONLY = "Marketing Only"
export const REALTOR = "Realtor"

export const ASSIGNABLE_RANKS = ['A', 'B', 'C']
/** Rank applied when a Prospect is created by an automated flow. Replaces the old 'O'. */
export const DEFAULT_AUTO_RANK = 'C'

export const TIME_FORMAT_24 = 'HH:mm'
export const TIME_FORMAT_12 = 'hh:mm'

export const TEXT_OUT_ACTIVITY = 'Text Out'
export const VIDEO_TEXT_OUT_ACTIVITY = 'Video Text Out'

export const AppointmentPurpose = {
  INITIAL_VISIT: 'Initial Visit',
  PRICING_APPOINTMENT: 'Pricing Appointment',
  BE_BACK: 'Be Back',
  CONTRACT_APPOINTMENT: 'Contract Appointment',
  OTHER: 'Other'
}